import { userConstants } from "../constants/login.constants";

 function asicInvoiceReport(state = {}, action) {
    switch (action.type) {
        case userConstants.ASICINVOICEREPORT_REQUEST:
            return {
                loading: true
            };
        case userConstants.ASICINVOICEREPORT_SUCCESS:
            return {
                items: action.viewCurrentAnnualStatementReport
            };
        case userConstants.ASICINVOICEREPORT_FAILURE:
            return {
                error: action.errorAsicInvoiceReport
            };
        default:
            return state
    }
}
export default asicInvoiceReport;